import React, { Component } from "react";
import PropTypes from "prop-types";

import { TextField, GroupField, FieldLabel } from "react-invenio-forms";
import { Button, Form, Icon } from "semantic-ui-react";

import { emptyContactEmails } from "./initialValues";
import { i18next } from "@translations/invenio_rdm_records/i18next";
import { ArrayField } from "../Overrides";

export class ContactEmailsField extends Component {
  render() {
    const { fieldPath, label, labelIcon, required, showEmptyValue } = this.props;

    return (
      <ArrayField
        addButtonLabel={i18next.t("Add Contact Email")}
        defaultNewValue={emptyContactEmails}
        fieldPath={fieldPath}
        helpText="The contact email/s information for this resource"
        label={<FieldLabel htmlFor={fieldPath} icon={labelIcon} label={label} />}
        required={required}
        showEmptyValue={showEmptyValue}
      >
        {({ arrayHelpers, indexPath }) => {
          const fieldPathPrefix = `${fieldPath}.${indexPath}`;

          return (
            <GroupField optimized>
              <TextField
                fieldPath={`${fieldPathPrefix}.contact_email`}
                label={i18next.t("Contact Email")}
                required
                width={16}
              />
              <Form.Field>
                <Button
                  aria-label={i18next.t("Remove field")}
                  className="close-btn"
                  icon
                  onClick={() => arrayHelpers.remove(indexPath)}
                >
                  <Icon name="close" />
                </Button>
              </Form.Field>
            </GroupField>
          );
        }}
      </ArrayField>
    );
  }
}

ContactEmailsField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  required: PropTypes.bool,
  showEmptyValue: PropTypes.bool,
};

ContactEmailsField.defaultProps = {
  label: i18next.t("Contact emails"),
  labelIcon: "mail",
  required: false,
  showEmptyValue: false,
};
